import React from "react";

const ProfessionIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      d="M21.333 8H20.8c-4.48 0-6.72 0-8.432.872a8 8 0 00-3.496 3.496C8 14.08 8 16.32 8 20.8v.533M21.333 56H20.8c-4.48 0-6.72 0-8.432-.872a8 8 0 01-3.496-3.496C8 49.92 8 47.68 8 43.2v-.533m48-21.334V20.8c0-4.48 0-6.72-.872-8.432a8 8 0 00-3.496-3.496C49.92 8 47.68 8 43.2 8h-.533M56 42.667v.533c0 4.48 0 6.72-.872 8.432a8 8 0 01-3.496 3.496C49.92 56 47.68 56 43.2 56h-.533M20 21.333v4m24-4v4M29.333 33.6c2.134 0 4-1.866 4-4v-8.267m7.2 19.2c-4.8 4.8-12.533 4.8-17.332 0"
      stroke="#8065C9"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProfessionIcon;
